import http from '@utils/http'
/**
 *
 * @param data 可升级套餐列表
 */
export function queryService(data): Promise<any> {
    return http.post('/simPlanChange/queryService', data || {}, '')
}
/**
 *
 * @param data 获取当前套餐信息
 */
export function queryCurrentUserGoods(data): Promise<any> {
    return http.post('/simPlanChange/queryCurrentUserGoods', data || {}, '')
}
/**
 *
 * @param data 计算升级套餐价格
 */
export function caculateUpgradeCost(data): Promise<any> {
    return http.post('/simPlanChange/calculateUpgradeCost', data || {}, '')
}
/**
 *
 * @param data 查询可升级套餐
 */
export function queryUserGoodsChange(data): Promise<any> {
    return http.post('/simPlanChange/queryUserGoodsChange', data || {}, '')
}
/**
 *
 * @param data 查询可用套餐
 */
export function queryUsePlan(data): Promise<any> {
    return http.post('/podpage/queryUsePlan', data || {}, '')
}
/**
 *
 * @param data 查询历史套餐
 */
export function queryUserHistoryPlan(data): Promise<any> {
    return http.post('/podpage/queryUserHistoryPlan', data || {}, '')
}

/**
 *
 * @param data 查询过期未启用套餐
 */
export function getOutDateList(data): Promise<any> {
    return http.post('/podpage/queryManulActiveExpiredPlan', data || {}, '')
}
/**
 *
 * @param data 手动激活
 */
export function manualActive(data): Promise<any> {
    return http.post('/sim/manualActive', data || {}, '')
}
